export default "__VITE_ASSET__90de85af__"